const debug = false;
const log = (message) => {
  debug && console.log(message);
};

export { log };
